import React, { useState } from "react";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Message sent! We'll get back to you shortly.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="text-gray-800">
      {/* Header */}
      <section className="bg-primary text-white py-20 px-6 text-center">
        <h1 className="text-4xl font-bold">Get in Touch</h1>
        <p className="mt-2 text-white/90 text-lg">
          We’d love to hear about your networking needs or questions.
        </p>
      </section>

      {/* Contact Content */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">
          {/* Contact Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold mb-1" htmlFor="name">Your Name</label>
              <input
                type="text"
                name="name"
                id="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-accent"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1" htmlFor="email">Your Email</label>
              <input
                type="email"
                name="email"
                id="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-accent"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-1" htmlFor="message">Message</label>
              <textarea
                name="message"
                id="message"
                rows="5"
                required
                value={formData.message}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-accent"
              ></textarea>
            </div>

            <button
              type="submit"
              className="bg-accent text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              Send Message
            </button>
          </form>

          {/* Contact Info with Logo */}
          <div className="bg-gray-50 p-6 rounded-xl shadow-sm space-y-4 text-sm text-center">
            <img
              src="/assets/Logo.png"
              alt="NKT Logo"
              className="h-25 mx-auto mb-4 rounded-tr-full rounded-bl-full"
            />
            <h2 className="text-xl font-semibold mb-4">Contact Details</h2>
            <p>
              <strong>Address:</strong><br />
              New Krishna Technologies<br />
              P. No. 2 Balnath Nager, Jhotwara Jaipur
            </p>
            <p>
              <strong>Phone:</strong><br />
              📞+91 9785442520<br />
              📞+91 9887919299<br />
              📞+91 8058971243
            </p>
            <p>
              <strong>Email:</strong><br />
              ✉️support@nktinfo.com
            </p>
            <p>
              <strong>Working Hours:</strong><br />
              Mon – Sat: 9:30 AM – 6:30 PM
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
